import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  paperStyle: {
    padding: '6px',
    marginBottom: '10px',
  },
  textIcon: {
    textDecoration: 'underline',
    display: 'flex',
    '& p': {
      marginLeft: '10px',
    },
  },
  textStyle: {
    display: 'grid',
    marginLeft: '15px',
    '& P': {
      lineHeight: '.5',
    },
  },
  mainGrid: {
    minHeight: '110px',
  },
  dividerStyle: {
    height: '110px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textFlex: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  divider: {
    marginTop: 15,
    marginBottom: 15,
  },
  textFlexCenter: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-around',
    textAlign: 'center',
    margin: '10px',
  },
  imageStyle: {
    width: '100%',
  },
  gridEditButton: {
    display: 'flex',
    alignItems: 'center',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  servicesIconsPaper: {
    backgroundColor: '#f5f5f5',
    height: '95%',
    paddingRight: 30,
    paddingLeft: 30,
  },
  servicesIconsGrid: {
    textAlign: 'center',
  },
  servicesPaperTitle: {
    marginBottom: '10%',
    color: '#c4c4c4',
  },
  formGroupRow: {
    flexDirection: 'row',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  marginStyle: {
    marginTop: '10px',
    marginBottom: '10px',
  },
}));

export default styles;
